import axios from 'axios'
import {API} from 'src/feature/bite/domain'
import {getTimeZone} from 'src/feature/bite/helpers/date'

interface MerchantForm {
  merchantID: string
  name: string
  surname: string
  email: string
  phone: string
  titleID: string
  timeZoneOffset: string | number
}

interface MerchantResponse {
  response: any
  responseResult: {
    result: boolean
    exceptionDetail: string
  }
}

export default async function submitForm(merchantForm: MerchantForm) {
  const timeZoneOffset = getTimeZone()
  merchantForm = {
    ...merchantForm,
    timeZoneOffset: timeZoneOffset,
  }

  const response = await axios.post<MerchantResponse>(
    `${API}/Merchant/CreateMerchant`,
    merchantForm
  )
  if (response.data.responseResult.result) {
    return {
      status: true,
      message: 'Success',
      merchantID: response.data.response.merchantID,
    }
  } else {
    return {
      status: false,
      message: response.data.responseResult.exceptionDetail,
      merchantID: '',
    }
  }
}
